import { Component } from '@angular/core';

@Component({
  selector: 'app-awaiting-signer-acknowledgement',
  templateUrl: './awaiting-signer-acknowledgement.component.html',
  styleUrls: ['./awaiting-signer-acknowledgement.component.scss'],
  standalone: false,
})
export class AwaitingSignerAcknowledgementComponent {
  static identifier = 'AwaitingSignerAcknowledgementComponent';
}
